import type { ColDef } from "ag-grid-community";
import type { CustomCellRendererProps } from "ag-grid-react";
import type { Instrument } from "../../const";
import { withCellMarker } from "../withCellMarker";
import { isPulsing } from "./sizingMessage";
import styles from "./sizingMessagePulse.module.css";

/**
 * The quantity, pulsing blue. Keyed by when the message landed, so a new message on the same row
 * pulses again.
 */
export function SizingMessagePulseCell({
	data,
	value,
	valueFormatted,
}: CustomCellRendererProps<Instrument>): React.JSX.Element {
	return (
		<div
			key={data?.sizingMessage?.receivedAt}
			className={styles.pulse}
			data-qualifier="CompositionEditor/SizingMessagePulse"
		>
			{valueFormatted ?? (value == null ? "" : String(value))}
		</div>
	);
}

/**
 * Pulses the quantity of a row whose message just landed. Only for the length of the pulse: a cell
 * drawn later, once scrolled back into view, shows the quantity as usual.
 */
export function withSizingMessagePulse(column: ColDef<Instrument>): ColDef<Instrument> {
	return withCellMarker(column, {
		applies: (row) => isPulsing(row.sizingMessage, Date.now()),
		Marker: SizingMessagePulseCell,
	});
}
